'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:employee-list
 * @description
 * # employee-list
 * Directive to generate a project index
 */
angular.module('thothApp.directives')
.directive('employeeList', function() {
  return {
    restrict: 'E',
    templateUrl: 'views/employees/_list.html',
    controller: ['$scope', '$state', 'Employee', 'Pagination', '$mdDialog', function ($scope, $state, Employee, Pagination, $mdDialog) {
      $scope.employees = {
        list: [],
        pager: {}
      };


      $scope.statusList = [
        {
          name: 'Todos',
          id: null
        },
        {
          name: 'Activos',
          id: true
        },
        {
          name: 'Inactivos',
          id: false
        },
      ];

      $scope.status_selected = $scope.statusList[1];
      $scope.search = {
        'search': '',
        'by_column': {
          'column': 'employee_code',
          'order': 'ASC'
        },
        'by_status': true,
        'assignable': null
      };

      $scope.filters = {
        employee_code: 'fa-sort-asc',
        name: 'fa-sort',
        'users.email': 'fa-sort',
        is_rape: 'fa-sort',
        is_admin_group: 'fa-sort',
        is_active: 'fa-sort',
        workspace_id: 'fa-sort',
        employee_position_id: 'fa-sort',
        assignable: 'fa-sort'
      };

      $scope.clearSearch = function() {
        $scope.search = {
          'search': '',
          'by_column': '',
          'by_status': '',
          'assignable': ''
        };
        $scope.filters = {
          employee_code: 'fa-sort-asc',
          name: 'fa-sort',
          'users.email': 'fa-sort',
          is_rape: 'fa-sort',
          is_admin_group: 'fa-sort',
          is_active: 'fa-sort',
          workspace_id: 'fa-sort',
          employee_position_id: 'fa-sort',
          assignable: 'fa-sort'
        };
        $scope.getPage(1);
      };

      $scope.getPage = function(page, optionalParams) {
        var params;
        if (optionalParams) {
          params = optionalParams;
        } else {
          var q = {
            page: page,
            per_page: 10,
            search: $scope.search.search,
            by_column: {
              column: $scope.search.by_column.column,
              order:  $scope.search.by_column.order
            },
            by_status: $scope.search.by_status
          };
          if ($scope.search.assignable !== null && $scope.search.assignable !== undefined && $scope.search.assignable !== '') {
            q.assignable = $scope.search.assignable;
          }
          params = { params: q };
        }
        Employee.index(params).then(function(response) {
          $scope.employees.list = response.data.employees;
          $scope.employees.pager = Pagination.GetPager(
            response.data.meta.pagination.total_objects,
            page,
            response.data.meta.pagination.per_page
          );
        },function(error) {
          Employee.error(error);
        });
      };

      $scope.getPage(1);

      $scope.filter = function(column) {
        var order = '';
        angular.forEach($scope.filters, function(value, key) {
          if(column === key) {
            if($scope.filters[key] === 'fa-sort-desc') {
              $scope.filters[key] = 'fa-sort-asc';
              order = 'ASC';
            } else {
              $scope.filters[key] = 'fa-sort-desc';
              order = 'DESC';
            }
          } else {
            $scope.filters[key] = 'fa-sort';
          }
        });
        $scope.search.by_column = {
          column: column,
          order: order
        };
        $scope.getPage(1);
      };

      function DialogController($scope, $mdDialog, name) {
        $scope.name = name;
        $scope.cancel = function() {
          $mdDialog.hide(false);
        };

        $scope.confirm = function() {
          $mdDialog.hide(true);
        };
      }

      $scope.addStatusFilter = function(){
        if ($scope.search.by_status !== $scope.status_selected.id) {
          $scope.search.by_status = $scope.status_selected.id;
          $scope.getPage(1);
        }
      };

      $scope.setAssignableFilter = function(val){
        $scope.search.assignable = val;
        $scope.getPage(1);
      };

      $scope.deleteEmployee = function(employee) {
        var index = $scope.employees.list.indexOf(employee);
        $mdDialog.show({
          template:
            '<md-dialog aria-label="Eliminando">' +
            '  <md-dialog-content>' +
            '    <div class="col-md-12">' +
            '      <h3>Estas seguro de querer eliminar a {{name}}</h3>' +
            '    </div>' +
            '  </md-dialog-content>' +
            '  <md-dialog-actions>' +
            '    <md-button ng-click="cancel()" class="md-warn">No</md-button>' +
            '    <md-button ng-click="confirm()" class="md-primary">Confirmar</md-button>' +
            '  </md-dialog-actions>' +
            '</md-dialog>',
            locals: {
              name: employee.name
            },
            controller: DialogController
        }).then(function(response) {
          if(response) {
            Employee.delete(employee.id).then(function() {
              $scope.employees.list.splice(index, 1);
            }, function(error) {
              Employee.error(error);
            });
          }
        });
      };
    }]
  };
});
